/* eslint-disable */
import customModal from "../customModal/customModal.vue";

export default {
    name: "QTLDetailsModal",
    components: {
        customModal,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    emits: ["closeModal"],
    data() {
        return {
            qtlDetails: {
                thresholds: []
            }
        };
    },
    mounted() {
        if (this.data) {
            this.qtlDetails = this.data;
        }
    },
    watch: {
        data: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.qtlDetails = newVal;
                }
            }
        }
    },
    methods: {
        closeModal() {
            this.$emit("closeModal");
        }
    }
};